import { render, staticRenderFns } from "./EditPanel.vue?vue&type=template&id=1415d4ff&scoped=true&"
import script from "./EditPanel.vue?vue&type=script&lang=js&"
export * from "./EditPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1415d4ff",
  null
  
)

export default component.exports